module.exports = __webpack_public_path__ + "img/login_logo.092e0eb4.png";